<template>
  <ToggleSection
    label="Acquisition Details"
    icon-classes="fa-solid fa-microscope"
    :collapsed="!dv.isEditing"
  >
    <FieldGrid
      class="form-fields"
      :fields="[
        ['detector_type', 'pixel_size_value'],
        ['high_tension', 'primary_beam_current'],
        ['tile_x_size', 'tile_y_size'],
        ['tile_overlap', 'amount_of_images'],
        ['dwell_time', 'line_average'],
        ['slice_thickness'],
        ['fibsem_milling_current'],
      ]"
      :dv="dv"
    >
      <template #pixel_size_value>
        <FieldComponent
          :field-meta="dv.modelAttributes['pixel_size_value']"
          :data="dv.editedRecord['pixel_size_value']"
          :is-edit-mode="dv.isEditing"
          @edit="(value) => dv.edit({ name: 'pixel_size_value' }, value)"
        />
        <FieldComponent
          :field-meta="dv.modelAttributes['pixel_size_unit']"
          :data="dv.editedRecord['pixel_size_unit']"
          :is-edit-mode="dv.isEditing"
          @edit="(value) => dv.edit({ name: 'pixel_size_unit' }, value)"
        />
      </template>
    </FieldGrid>
  </ToggleSection>
</template>

<script>
import ToggleSection from '@/components/fields/ToggleSection.vue'
import FieldGrid from '@/components/fields/FieldGrid.vue'

export default {
  name: 'VolumeEMDatasetAcquisitionDetails',
  components: {
    ToggleSection,
    FieldGrid,
  },
  props: {
    dv: { type: Object, required: true },
  },
}
</script>
